import type { ComponentType } from "react";
import { ChevronDown } from "lucide-react";

interface CollapsibleWidgetProps {
  projectId: string;
  component: ComponentType<{ projectId: string }>;
  isExpanded: boolean;
  onToggle: () => void;
  headerColor?:
    | "purple"
    | "green"
    | "orange"
    | "blue"
    | "pink"
    | "yellow"
    | "indigo"
    | "red";
}

export default function CollapsibleWidget({
  projectId,
  component: Component,
  isExpanded,
  onToggle,
  headerColor = "purple",
}: CollapsibleWidgetProps) {
  const getHoverColorClass = () => {
    const colorMap = {
      purple: "hover:bg-purple-100",
      green: "hover:bg-green-100",
      orange: "hover:bg-orange-100",
      blue: "hover:bg-blue-100",
      pink: "hover:bg-pink-100",
      yellow: "hover:bg-yellow-100",
      indigo: "hover:bg-indigo-100",
      red: "hover:bg-red-100",
    };
    return colorMap[headerColor];
  };

  return (
    <div className="relative">
      <div className={isExpanded ? "" : "[&>div>div:last-child]:hidden"}>
        <Component projectId={projectId} />
      </div>
      <button
        onClick={onToggle}
        className={`absolute top-4 right-4 p-1 ${getHoverColorClass()} rounded transition-colors z-10`}
        aria-label={isExpanded ? "Collapse section" : "Expand section"}
      >
        <ChevronDown
          className={`w-5 h-5 transition-transform ${
            isExpanded ? "rotate-180" : ""
          }`}
          strokeWidth={3}
        />
      </button>
    </div>
  );
}
